export default __webpack_public_path__ + "static/davidizatt-9346a13d3eb61a72fb612cf74c5acad2.png";